import React, { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import ReactCountryFlag from "react-country-flag";
import Dropdown, { Option } from "react-dropdown";
import axios from "axios";
import { RotatingLines } from "react-loader-spinner";
import Button from "react-bootstrap/Button";
import "react-dropdown/style.css";
import Chart from "./Chart";

interface CountryCode {
	code: string;
	currency: string;
}

export interface History {
	fromCurrency: string;
	toCurrency: string;
	amount: string | null;
	rate: string;
	timestamp: number;
}
const countryCodes: { [code: string]: CountryCode } = {
	US: {
		code: "USD",
		currency: "$"
	},
	EU: {
		code: "EUR",
		currency: "€"
	},
	EG: {
		code: "EGP",
		currency: "EGP "
	},
	PL: {
		code: "PLN",
		currency: "zł"
	}
};

const options: Option[] = [
	{
		value: "US",
		label: (
			<ReactCountryFlag
				countryCode="US"
				svg
				style={{
					width: "2em",
					height: "2em"
				}}
				title="US"
			/>
		)
	},
	{
		value: "EU",
		label: (
			<ReactCountryFlag
				countryCode="EU"
				svg
				style={{
					width: "2em",
					height: "2em"
				}}
				title="EU"
			/>
		)
	},
	{
		value: "PL",
		label: (
			<ReactCountryFlag
				countryCode="PL"
				svg
				style={{
					width: "2em",
					height: "2em"
				}}
				title="PL"
			/>
		)
	},
	{
		value: "EG",
		label: (
			<ReactCountryFlag
				countryCode="EG"
				svg
				style={{
					width: "2em",
					height: "2em"
				}}
				title="EG"
			/>
		)
	}
];
// const defaultOption = options[0];
export const App = () => {
	const [firstAmount, setFirstAmount] = useState("1000.00");
	const [firstAmountState, setFirstAmountState] = useState("1000.00");
	const [secondAmount, setSecondAmount] = useState("");
	const [firstCurrency, setFirstCurrency] = useState<null | CountryCode>(
		countryCodes[options[0].value]
	);
	const [secondCurrency, setSecondCurrency] = useState<null | CountryCode>(
		countryCodes[options[3].value]
	);
	const [result, setResult] = useState<null | any>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [showHistory, setShowHistory] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		axios
			.get(
				`https://binance-p2p-api-zon6tf6nta-uc.a.run.app/api/convert?from=${firstCurrency?.code}&to=${secondCurrency?.code}&amount=${firstAmount}`
			)
			.then(res => {
				setResult(res.data);
				setSecondAmount(res.data.convertedQty);
				setIsLoading(false);
			});
	}, [firstCurrency, secondCurrency, firstAmount]);

	return (
		<>
			{isLoading && (
				<div
					style={{
						position: "absolute",
						width: "100%",
						height: "100%",
						background: "rgba(52, 52, 52, 0.8)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 100
					}}
				>
					<RotatingLines
						visible={true}
						width="60"
						strokeWidth="2"
						strokeColor="#0dcaf0"
						animationDuration="0.75"
						ariaLabel="rotating-lines-loading"
					/>
				</div>
			)}
			<div
				style={{
					display: "grid",
					alignItems: "center",
					justifyContent: "center",
					maxWidth: "75%",
					margin: "auto"
				}}
			>
				<h1>Currency Converter</h1>
				<h3>From</h3>
				<div style={{ display: "flex", width: "100%" }}>
					<Dropdown
						options={options}
						value={options[0]}
						placeholder="Select Currency"
						onChange={value => {
							const countryCode = countryCodes[value.value];
							setFirstCurrency(countryCode);
						}}
					/>
					<CurrencyInput
						style={{ width: "inherit" }}
						id="input-example"
						name="input-name"
						prefix={firstCurrency?.currency}
						placeholder="Please enter amount"
						defaultValue={firstAmount}
						value={firstAmountState}
						decimalsLimit={2}
						autoFocus
						onValueChange={value => {
							setFirstAmountState(value || "");
						}}
						onBlur={() => {
							setFirstAmount(firstAmountState);
						}}
						onKeyUp={event => {
							if (event.key === "Enter") {
								setFirstAmount(firstAmountState);
							}
						}}
					/>
				</div>
				<h3>To</h3>
				<div style={{ display: "flex", width: "100%" }}>
					<Dropdown
						options={options}
						value={options[3]}
						placeholder="Select Currency"
						onChange={value => {
							const countryCode = countryCodes[value.value];
							setSecondCurrency(countryCode);
						}}
					/>
					<CurrencyInput
						style={{ width: "inherit" }}
						id="input-example"
						name="input-name"
						prefix={secondCurrency?.currency}
						placeholder="Please enter amount"
						defaultValue={secondAmount}
						value={Number(secondAmount).toFixed(2)}
						decimalsLimit={2}
						disabled
					/>
				</div>
				<div
					style={{
						display: "flex",
						marginTop: "40px",
						justifyContent: "space-evenly"
					}}
				>
					<Button
						style={{ width: "45%" }}
						variant="info"
						onClick={() => setShowDetails(value => !value)}
					>
						{showDetails ? "Hide " : "Show "}Info
					</Button>
					<Button
						style={{ width: "45%" }}
						variant="secondary"
						onClick={() => setShowHistory(value => !value)}
					>
						{showHistory ? "Hide " : "Show "}History
					</Button>
				</div>
				{showDetails && (
					<div style={{ display: "grid", margin: "auto" }}>
						<pre style={{ overflow: "auto" }}>{`${JSON.stringify(
							result,
							null,
							1
						)}`}</pre>
					</div>
				)}
				{
					<div style={{ display: showHistory ? "grid" : "none"}}>
						<Chart/>
					</div>
				}
			</div>
		</>
	);
};

export default App;
